var local_time_view_form = $('#local_time_view_form');

if (local_time_view_form.length) {
    var demo_all;

    $('#local_view_market_no').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 10
    });

    $('#time_view_group_by').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: Infinity
    });
    $('#form_sort_by').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 10,
    });

    $('#time_view_year').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 10,
        'allowClear': true
    });

    $('#avails_view_demo').select2({
        placeholder: "Select one...",
        minimumResultsForSearch: 10,
    });

    $('#radio_interval input').each(function () {
        if (this.checked)
            $(this).prop('checked', false);
        if($(this).val() === 'all_year')
            $(this).prop('checked', true);
    });

    $("#stream").select2()

    $("#time_view_station_no").multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div style='height: 38px;font-color:grey'><label></label></div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values) {
            this.qs1.cache();
        },
        afterDeselect: function(values) {
            this.qs1.cache();
        },
    });
    $('#form_dayparts').multiSelect({
        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
        selectionHeader: "<div style='height: 38px;'><label></label></div>",
        afterInit: function(ms){
            var that = this,
                $selectableSearch = that.$selectableUl.prev(),
                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                .on('keydown', function(e){
                    if (e.which === 40){
                        that.$selectableUl.focus();
                        return false;
                    }
                });
        },
        afterSelect: function(values){
            this.qs1.cache();

            form_curr_dayparts = this.$element.val();
            if(this.$element.val().length <= 15){

            }else{
                this.$element.multiSelect('deselect', values);
                form_curr_dayparts = this.$element.val();

                swal({
                        title: "The max number is 15 ...",
                        text: "",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: "Close",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {

                    });
            }

            if(form_curr_dayparts.length < 15){
                this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
            }else{
                this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-muted').addClass('text-warning');
            }
        },
        afterDeselect: function(values){
            this.qs1.cache();

            form_curr_dayparts = this.$element.val();

            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
        }
    });


    $.ajax({
        type: "GET",
        url: '/comscore/tv/local/markets',
        dataType: 'json',
        success: function (data) {
            console.log(data);
            var html = '';
            html+= '<option value="">Select one...</option>';
            $.each(data['result_rows'], function (index, value) {
                html += '<option value="'+ value[0] +'" data-start="' + value[2] + '" data-end="' + value[3] + '">'+ value[1] +'</option>';
            });
            $("#local_view_market_no").append(html);
        },
        error: function (err) {
            console.log(err);
            hide_loader();
        }
    });
    $.ajax({
        type: "GET",
        url: '/ratings/comscore/metadata/demographics ',
        dataType: 'json',
        success: function (data) {
            console.log(data);
            var html = '';
            html+= '';
            demo_all= data['result_rows'];
            demo_all.sort(function(a,b){
                var au = a[2];
                var bu = b[2];
                return au.toString().localeCompare(bu);
            });
            var demo= $('input:radio[name=primary_demo_type]:checked').val();
            $("#seldemo").val("");
            $.each(data['result_rows'], function (index, value) {
                /* if(value[11].indexOf('Age Range') !== -1)
                  html += '<option value="'+ value[0] +'">'+ value[1] +'</option>';*/

                if(value[10].indexOf('Age Range') !== -1){
                    if(demo== 'p') {
                        if (value[1].indexOf('A') !== -1) {
                            var ts= value[1].replace("A1", "P 1").replace("A2", "P 2").replace("A3", "P 3").replace("A4", "P 4").replace("A5", "P 5").replace("A6", "P 6");
                            html += '<option value="' + value[0] + '">' + ts + '</option>';
                            if($("#seldemo").val() === "")
                                $("#seldemo").val(ts);
                        }
                    }
                    if(demo== 'm') {
                        if (value[1].indexOf('M') !== -1) {
                            var ts= value[1].replace("M1", "M 1").replace("M2", "M 2").replace("M3", "M 3").replace("M4", "M 4").replace("M5", "M 5").replace("M6", "M 6");
                            html += '<option value="' + value[0] + '">' + ts + '</option>';
                            if($("#seldemo").val() === "")
                                $("#seldemo").val(ts);
                        }
                    }
                    if(demo== 'f') {
                        if (value[1].indexOf('W') !== -1) {
                            var ts= value[1].replace("W1", "F 1").replace("W2", "F 2").replace("W3", "F 3").replace("W4", "F 4").replace("W5", "F 5").replace("W6", "F 6");
                            html += '<option value="' + value[0] + '">' + ts + '</option>';
                            if($("#seldemo").val() === "")
                                $("#seldemo").val(ts);
                        }
                    }
                }
                if(value[10].indexOf('Household Composition') !== -1){
                    if(demo == 'hh') {
                        if(html == "") {
                            html += '<option value="0">---</option>';
                        }
                        html += '<option value="' + value[0] + '">' + value[1] + '</option>';
                        if($("#seldemo").val() === "")
                            $("#seldemo").val(value[1]);
                    }
                }

            });
            $("#avails_view_demo").html(html);
        },
        error: function (err) {
            console.log(err);
            hide_loader();
            debug(err.responseText);

        }
    });
    $("#local_view_market_no").on('change', function(){
        show_loader();
        var market= $("#local_view_market_no option:selected").val();
        var htmltoadd = ""
        var nowTime = (parseInt(moment($("#local_view_market_no option:selected").data("end")).format("YYYY")) < parseInt(moment().format("YYYY"))) ? parseInt(moment($("#local_view_market_no option:selected").data("end")).format("YYYY")) : parseInt(moment().format("YYYY"))
        var gtrTime = parseInt(moment($("#local_view_market_no option:selected").data("start")).format("YYYY"))
        while(nowTime >= gtrTime){
            htmltoadd += '<option value="' + nowTime + '-01-01">' + nowTime + '</option>';
            nowTime--
        }
        $("#time_view_year").html(htmltoadd).select2({
            placeholder: "Select one...",
            minimumResultsForSearch: 10,
            'allowClear': true
        })
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/stations/' + market,
            dataType: 'json',
            success: function (data) {
                var html = '';
                $.each(data['result_rows'], function (index, value) {
                    if(value[5] == market)
                        html += '<option value="'+ value[0] +'">'+ value[1] +' ('+ value[10] +')</option>';
                });
                $("#time_view_station_no").html(html);
                $("#time_view_station_no").multiSelect('refresh');

                $("#selmarket").val($("#local_view_market_no option:selected").text());

                hide_loader();
            },
            error: function (err) {
                hide_loader();
            }
        });
    });


    $('#primary_demo_type_avail input').on('change', function (e) {
        var demo= $('input:radio[name=primary_demo_type]:checked').val();
        var html='';
        $('#avails_view_demo').html(html);
        $("#seldemo").val("");
        $.each(demo_all, function (index, value) {
            if(value[10].indexOf('Age Range') !== -1){
                if(demo== 'p') {
                    if (value[1].indexOf('A') !== -1) {
                        var ts= value[1].replace("A1", "P 1").replace("A2", "P 2").replace("A3", "P 3").replace("A4", "P 4").replace("A5", "P 5").replace("A6", "P 6");
                        html += '<option value="' + value[0] + '">' + ts + '</option>';
                        if($("#seldemo").val() == "")
                            $("#seldemo").val(ts);
                    }
                }
                if(demo== 'm') {
                    if (value[1].indexOf('M') !== -1) {
                        var ts= value[1].replace("M1", "M 1").replace("M2", "M 2").replace("M3", "M 3").replace("M4", "M 4").replace("M5", "M 5").replace("M6", "M 6");
                        html += '<option value="' + value[0] + '">' + ts + '</option>';
                        if($("#seldemo").val() == "")
                            $("#seldemo").val(ts);
                    }
                }
                if(demo== 'f') {
                    if (value[1].indexOf('W') !== -1) {
                        var ts= value[1].replace("W1", "F 1").replace("W2", "F 2").replace("W3", "F 3").replace("W4", "F 4").replace("W5", "F 5").replace("W6", "F 6");
                        html += '<option value="' + value[0] + '">' + ts + '</option>';
                        if($("#seldemo").val() == "")
                            $("#seldemo").val(ts);
                    }
                }
            }
            if(value[10].indexOf('Household Composition') !== -1){
                if(demo == 'hh') {
                    if(html == "") {
                        html += '<option value="0">---</option>';
                    }
                    html += '<option value="' + value[0] + '">' + value[1] + '</option>';
                    if($("#seldemo").val() == "")
                        $("#seldemo").val("---");
                }
            }
        });
        $('#avails_view_demo').html(html);
    });
    $('#avails_view_demo').on('change', function(){
        var x=  $("#avails_view_demo option:selected");
        $("#seldemo").val($(x).text());

    });


    $('#form_submit').on('click', function (e) {

        var market= $("#local_view_market_no option:selected").val();
        var stations= $('#time_view_station_no');
        //var fields= $('#form_fields');
        var years= $('#time_view_year');
        var daypart= $('#form_dayparts');
        var p=false;
        var pp= false;

        if(market !== "")
        {
            if( $(stations).val().length !== 0 ) {
                p = true;
                pp= true;
            }
            else
                global_notification('warning','Please select at least one Station');
            /*if(p === true && pp === true && $(fields).val().length === 0){
                p = false;
                pp = false;
                global_notification('warning','Please select at least one Report column.');
            }*/
            if(p === true && pp === true && $(years).val().length === 0){
                p = false;
                pp = false;
                global_notification('warning','Please select at least one calendar year.');
            }
        }
        else
            global_notification('warning','Please select a Market');

        if($(daypart).val().length === 0 && p === true)
        {
            pp = false;
            global_notification('warning','Please select at least one Daypart');
        }
        if(pp === true) {
            var editing = false;
            if (editing === true) {
                $('#saved_report_id').val(general['id']);
                $('#reportable_id').val(edit['id']);
                $('#app-form-local-avail-views').attr('action', '/ratings/comscore/local_avail_views/edit');
                $('#app-form-local-avail-views').submit();
            }
            else {
                show_loader();
                $('#local_time_view_form').submit();
            }
        }
    });

}
